import { Card, LuIcon, Spinner, Text } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { type ComponentProps, memo } from "react"

import { modelIconMapping } from "../../mappings/icons"

interface FileThumbnailProps extends Omit<ComponentProps<typeof Card>, "children"> {
	file: File | null
	errored: boolean
}

export const FileThumbnail = memo((props: FileThumbnailProps) => {
	const { ref, className, file, errored, ...rest } = props

	const renderContent = () => {
		if (errored) {
			return (
				<div className="flex size-full items-center gap-2 text-xs">
					<LuIcon icon={modelIconMapping.alertCircle} color="var(--base-a11)" />
					<Text size="xs" className="truncate" accentColor="base">
						Errored
					</Text>
				</div>
			)
		}

		if (!file) {
			return (
				<div className="flex size-full items-center gap-2 text-xs">
					<Spinner size="xs" accentColor="base" />
					<Text size="xs" className="truncate" accentColor="base">
						Loading
					</Text>
				</div>
			)
		}

		return (
			<div className="flex size-full items-center gap-2 text-xs">
				<LuIcon icon={modelIconMapping.file} color="var(--base-a11)" />
				<Text size="xs" className="truncate" accentColor="base">
					{file.name}
				</Text>
			</div>
		)
	}

	return (
		<Card ref={ref} className={cx("p-2! h-12 w-max shrink-0 grow-0 overflow-hidden", className)} {...rest}>
			{renderContent()}
		</Card>
	)
})
FileThumbnail.displayName = "FileThumbnail"
